module.exports = __webpack_public_path__ + "static/img/banner1.6a62450.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner1.jpg
// module id = Fgek
// module chunks = 12